import { useThemeSlice } from "../ui/StatusBadge.jsx";
import { SkeletonBlock } from "./SkeletonBlock.jsx";
import { SkeletonRows } from "./SkeletonRows.jsx";

export function UsersRouteSkeleton() {
  const { c, dark } = useThemeSlice();
  const cardLift = dark
    ? "0 20px 42px rgba(0,0,0,.34)"
    : "0 16px 36px rgba(15,23,42,.10)";

  return (
    <div style={{ flex: 1, minHeight: 0, overflow: "hidden", padding: 14 }}>
      <div
        style={{
          background: c.card,
          border: `1px solid ${c.cardBdr}`,
          borderRadius: 12,
          height: "100%",
          minHeight: 0,
          display: "grid",
          gridTemplateColumns: "280px 1fr",
          overflow: "hidden",
          boxShadow: cardLift,
        }}
      >
        <div style={{ borderRight: `1px solid ${c.cardBdr}`, padding: "12px 10px", display: "flex", flexDirection: "column", gap: 10 }}>
          <SkeletonBlock height={32} />
          <SkeletonRows count={6} height={44} gap={6} />
        </div>
        <div style={{ padding: "20px 24px", display: "flex", flexDirection: "column", gap: 14 }}>
          <SkeletonBlock width={180} height={24} />
          <SkeletonBlock width={240} height={14} />
          <SkeletonBlock height={1} style={{ margin: "4px 0" }} />
          <SkeletonRows count={4} height={52} gap={10} />
        </div>
      </div>
    </div>
  );
}
